import { render, staticRenderFns } from "./PoliciesDiscountDetails.vue?vue&type=template&id=781344c8&scoped=true"
import script from "./PoliciesDiscountDetails.vue?vue&type=script&lang=ts"
export * from "./PoliciesDiscountDetails.vue?vue&type=script&lang=ts"
import style0 from "./PoliciesDiscountDetails.vue?vue&type=style&index=0&id=781344c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781344c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781344c8')) {
      api.createRecord('781344c8', component.options)
    } else {
      api.reload('781344c8', component.options)
    }
    module.hot.accept("./PoliciesDiscountDetails.vue?vue&type=template&id=781344c8&scoped=true", function () {
      api.rerender('781344c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policies-discounts/components/PoliciesDiscountDetails.vue"
export default component.exports